export default "__VITE_PUBLIC_ASSET__039cb107__"